// Single source of truth for row + header action sets.
// Both the dashboard list row and CampaignHeader consume this so behaviour stays identical
// across the two surfaces. See COMPONENT-BREAKDOWN.md §4.

import { CAMPAIGN_STATUS, CHANNEL } from '../constants';

export const ACTION = {
  VIEW: 'view',
  EDIT: 'edit',
  CANCEL: 'cancel',
  PAUSE: 'pause',
  RESUME: 'resume',
  DUPLICATE: 'duplicate',
  DELETE: 'delete',
  RESTORE: 'restore',
  HARD_DELETE: 'hardDelete',
};

export const getActions = (campaign, capabilities = {}) => {
  if (!campaign) return [];

  const { status, channels = [], deletedAt, anonymizedAt } = campaign;
  const actions = [];

  if (anonymizedAt) {
    if (capabilities.canCreate) actions.push(ACTION.DUPLICATE);
    if (capabilities.canHardDelete) actions.push(ACTION.HARD_DELETE);
    return actions;
  }

  if (deletedAt) {
    if (capabilities.canRestore) actions.push(ACTION.RESTORE);
    if (capabilities.canHardDelete) actions.push(ACTION.HARD_DELETE);
    return actions;
  }

  if (capabilities.canEdit && status === CAMPAIGN_STATUS.DRAFT) {
    actions.push(ACTION.EDIT);
  }
  if (capabilities.canEdit && status === CAMPAIGN_STATUS.SCHEDULED) {
    actions.push(ACTION.EDIT, ACTION.CANCEL);
  }
  // Pause is email-only in MVP. Upsell-only campaigns run until activeUntil.
  if (
    capabilities.canPause &&
    status === CAMPAIGN_STATUS.ACTIVE &&
    channels.includes(CHANNEL.EMAIL)
  ) {
    actions.push(ACTION.PAUSE);
  }
  if (capabilities.canResume && status === CAMPAIGN_STATUS.PAUSED) {
    actions.push(ACTION.RESUME);
  }
  if (capabilities.canCreate) actions.push(ACTION.DUPLICATE);
  if (
    capabilities.canDelete &&
    [CAMPAIGN_STATUS.DRAFT, CAMPAIGN_STATUS.COMPLETED].includes(status)
  ) {
    actions.push(ACTION.DELETE);
  }
  return actions;
};

// Returns the primary inline action for a row (the icon shown before the more-menu).
// Typically "view" for active/completed, "edit" for editable states.
export const getPrimaryRowAction = (campaign, capabilities = {}) => {
  if (!campaign) return ACTION.VIEW;
  const { status, deletedAt, anonymizedAt } = campaign;
  if (anonymizedAt || deletedAt) return ACTION.VIEW;
  if (capabilities.canEdit && [CAMPAIGN_STATUS.DRAFT, CAMPAIGN_STATUS.SCHEDULED].includes(status)) {
    return ACTION.EDIT;
  }
  if (capabilities.canResume && status === CAMPAIGN_STATUS.PAUSED) {
    return ACTION.RESUME;
  }
  if (status === CAMPAIGN_STATUS.COMPLETED) return ACTION.DUPLICATE;
  return ACTION.VIEW;
};
